import http from "@/http-common";

class AbsentLetterReasonConfigService {
    /**
     * Lấy danh sách cấu hình lý do xin nghỉ
     */
    getList() {
        return http.get("/absent-letter-v4/reason-config/list");
    }

    /**
     * Batch update toàn bộ cấu hình (thứ tự, bật/tắt, tên, nội dung gợi ý)
     * @param {Array} reasons - Danh sách lý do theo thứ tự mới
     */
    batchUpdate(reasons) {
        return http.put("/absent-letter-v4/reason-config/batch-update", {reasons});
    }

    /**
     * Thêm lý do custom mới
     * @param {string} displayName - 1-100 ký tự
     * @param {string} suggestedContent - Tối đa 500 ký tự
     */
    createCustomReason({displayName, suggestedContent}) {
        return http.post("/absent-letter-v4/reason-config/custom-reason/create", {
            displayName,
            suggestedContent
        });
    }

    /**
     * Xóa lý do custom
     * @param {string} customReasonId - UUID
     */
    deleteCustomReason(customReasonId) {
        return http.delete("/absent-letter-v4/reason-config/custom-reason/delete", {
            params: {customReasonId}
        });
    }
}

export default new AbsentLetterReasonConfigService();
